(()=>{
  if(customElements.get('hz-whatsapp-chat'))return;
  class HzWhatsAppChat extends HTMLElement{
    connectedCallback(){
      this.link=this.querySelector('.hz-wa-link');
      if(!this.link)return;
      this.refresh=()=>this.updateLink();
      this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.avoidStickyControls()})};
      this.link.addEventListener('pointerdown',this.refresh);
      this.link.addEventListener('click',this.refresh);
      window.addEventListener('resize',this.schedule,{passive:true});
      window.addEventListener('scroll',this.schedule,{passive:true});
      this.observed=new Set();
      this.resizeObserver=new ResizeObserver(this.schedule);
      this.mutations=new MutationObserver(this.schedule);
      this.mutations.observe(document.body,{childList:true,subtree:true});
      this.updateLink();this.schedule();
    }
    disconnectedCallback(){
      this.link?.removeEventListener('pointerdown',this.refresh);
      this.link?.removeEventListener('click',this.refresh);
      window.removeEventListener('resize',this.schedule);
      window.removeEventListener('scroll',this.schedule);
      this.mutations?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    updateLink(){
      const phone=(this.dataset.phone||'').replace(/\D/g,'');
      if(!/^\d{7,15}$/.test(phone)){this.hidden=true;return}
      this.hidden=false;
      let message=(this.dataset.message||'').trim();
      if(this.dataset.includePage==='true'){
        const current=new URL(location.href);
        let url;
        try{url=new URL(document.querySelector('link[rel="canonical"]')?.href||current.href)}catch{url=new URL(current.href)}
        if(url.origin!==current.origin)url=new URL(current.pathname,current.origin);
        const view=url.searchParams.get('view')||current.searchParams.get('view');
        url.search='';url.hash='';
        if(url.pathname==='/'&&/^hz-[a-z0-9-]+$/i.test(view||''))url.searchParams.set('view',view);
        const variant=current.searchParams.get('variant');
        if(url.pathname.includes('/products/')&&/^\d+$/.test(variant||''))url.searchParams.set('variant',variant);
        message+=(message?'\n':'')+url.href;
      }
      this.link.href='https://wa.me/'+phone+(message?'?text='+encodeURIComponent(message):'');
    }
    avoidStickyControls(){
      let height=0;
      for(const node of document.querySelectorAll('product-sticky-bar,.product-sticky-form__card,#preview-bar-iframe,#PBarNextFrameWrapper')){
        if(!this.observed.has(node)){this.observed.add(node);this.resizeObserver.observe(node)}
        const rect=node.getBoundingClientRect(),style=getComputedStyle(node);
        if(rect.height>0&&rect.top<innerHeight&&rect.bottom>=innerHeight-2&&style.visibility!=='hidden'&&Number(style.opacity)>0)height=Math.max(height,innerHeight-Math.max(0,rect.top));
      }
      this.style.setProperty('--wa-obstruction',Math.min(height,160)+'px');
    }
  }
  customElements.define('hz-whatsapp-chat',HzWhatsAppChat);
})();